query Message($id: ID!) {
  message(id: $id) {
    textBody
    htmlBody
    subject
  }
}
